export default __webpack_public_path__ + "static/media/alarmphone.83bf37e0.png";